export enum LaunchRelax {
  pt_BR = "pt_BR",
  es_ES = "es_ES",
  hu_HU = "hu_HU",
}
